import React, { useState } from 'react';
import OutfitRecommendations from './OutfitRecommendations.js';

function BodyResults({ analysis, image, onReset }) {
  const [activeOccasion, setActiveOccasion] = useState('casual');

  if (analysis.error) {
    return (
      <div className="results error">
        <h2>⚠️ Analysis Error</h2>
        <p>{analysis.error}</p>
        <button onClick={onReset} className="btn-primary">Try Another Photo</button>
      </div>
    );
  }

  const occasions = Object.keys(analysis.recommendations.occasions);

  return (
    <div className="results">
      <div className="result-header">
        <h2>Your Body Analysis</h2>
        <div className="confidence-badge">
          {analysis.confidence === 'high' ? '✓ High Confidence' : 'Medium Confidence'}
        </div>
      </div>

      <div className="result-image">
        <img src={image} alt="Your analyzed body" className="analyzed-photo" />
      </div>

      <div className="analysis-grid">
        <div className="analysis-card primary">
          <h3>Body Shape</h3>
          <div className="body-shape-name">{analysis.bodyShape}</div>
          <p>{analysis.characteristics}</p>
        </div>

        <div className="analysis-card">
          <h3>Skin Undertone</h3>
          <div className="tone-name">{analysis.skinTone}</div>
          <p>Determined from photo analysis</p>
        </div>
      </div>

      <div className="recommendations">
        <h3>💡 Styling Tip for You</h3>
        <p style={{fontSize: '1.1rem', lineHeight: '1.6', color: '#555'}}>
          {analysis.recommendations.bodyTips}
        </p>
      </div>

      <div className="color-combo-section">
        <h3>🎨 Best Color Combinations for You</h3>
        <div className="color-palette-advanced">
          {analysis.recommendations.colorCombinations.map((combo, idx) => (
            <div key={idx} className="color-combo">
              <div className="color-main" style={{background: combo.mainHex}}>
                {combo.main}
              </div>
              <div className="color-accent" style={{background: combo.accentHex}}>
                {combo.accent}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="occasion-section">
        <h3>👔 Outfit Recommendations by Occasion</h3>
        
        <div className="occasion-tabs">
          {occasions.map(occ => (
            <button
              key={occ}
              className={`occasion-tab ${activeOccasion === occ ? 'active' : ''}`}
              onClick={() => setActiveOccasion(occ)}
            >
              {analysis.recommendations.occasions[occ].icon} {analysis.recommendations.occasions[occ].title}
            </button>
          ))}
        </div>

        <div className="occasion-content">
          <h4>{analysis.recommendations.occasions[activeOccasion].title}</h4>
          <div className="outfit-grid">
            {analysis.recommendations.occasions[activeOccasion].outfits.map((outfit, idx) => (
              <div key={idx} className="outfit-card">
                <div className="outfit-emoji">{outfit.emoji}</div>
                <div className="outfit-name">{outfit.name}</div>
                <div className="outfit-desc">{outfit.desc}</div>
              </div>
            ))}
          </div>
          
          <div style={{marginTop: '20px', padding: '15px', background: '#f0f9ff', borderRadius: '12px'}}>
            <strong>Recommended Colors:</strong> {analysis.recommendations.occasions[activeOccasion].colors.join(', ')}
          </div>
        </div>
      </div>

      <OutfitRecommendations 
        bodyShape={analysis.bodyShape}
        skinTone={analysis.skinTone}
        activeOccasion={activeOccasion}
      />

      <div className="actions">
        <button onClick={onReset} className="btn-secondary">Analyze Another Photo</button>
        <button className="btn-primary" onClick={() => alert('Full style report saved!')}>
          Save Style Guide
        </button>
      </div>

      <div className="share-section">
        <p>Found your perfect style? Share it!</p>
        <div className="share-buttons">
          <button className="share-btn" onClick={() => {
            const text = `I discovered I have a ${analysis.bodyShape} body shape! Find yours at`;
            const url = window.location.href;
            window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
          }}>
            Share on X/Twitter
          </button>
          <button className="share-btn" onClick={() => {
            alert('Screenshot your style guide and share on Instagram with #FaceAndStyle!');
          }}>
            Share on Instagram
          </button>
        </div>
      </div>
    </div>
  );
}

export default BodyResults;